import styled from 'react-emotion';
import { Image } from 'spectacle';

export default styled(Image)`
  border-radius: 0.25rem;
  box-shadow: 0 0 1rem -0.25rem black;
`;
